import { getEstablishmentById } from "../../../../services";

export const fetchEstbalishment = async (establishementId: number) => {
    const getEstablishementByIdRes = await getEstablishmentById(
        establishementId
    );
    if (!getEstablishementByIdRes.detail) {
        return getEstablishementByIdRes;
    }
    return null;
};
